export const UNIT_TYPE_EVENT_DELETE_OPEN_MODAL = "UNIT_TYPE_EVENT_DELETE_OPEN_MODAL";
export const UNIT_TYPE_EVENT_DELETE_REQUEST = "UNIT_TYPE_EVENT_DELETE_REQUEST";
export const UNIT_TYPE_EVENT_DELETE_RESULT = "UNIT_TYPE_EVENT_DELETE_RESULT";